import { render } from "./search-tag.html?vue&type=template&id=19d5e69a"
import script from "./search-tag.vue?vue&type=script&lang=js"
export * from "./search-tag.vue?vue&type=script&lang=js"

import "./search-tag.vue?vue&type=style&index=0&id=19d5e69a&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-search-bar/standard/search-tag.vue'],['render',render],['__file',"search-tag.vue"]])

export default __exports__